import { ErrorWithLabelMessage } from 'ap-openapi';
import { useMemo } from 'react';

export type UseInfoTagCellProps = {
  errorMessages?: ErrorWithLabelMessage[];
  messageType: string[];
};

export const useInfoTagCell = ({
  errorMessages,
  messageType,
}: UseInfoTagCellProps) => {
  const filteredMessages = useMemo(() => {
    return (
      errorMessages?.filter((msg) =>
        messageType.includes(msg.message_type || '')
      ) || []
    );
  }, [errorMessages, messageType]);

  return {
    filteredMessages,
  };
};
